export default class MeusEventosConstants {
  public static readonly TAB_LISTA = [
    {
      id: '1',
      name: 'Todos os eventos',
      width: '20%',
      icon: 'pi pi-calendar'
    },
    {
      id: '2',
      name: 'Eventos Abertos',
      width: '20%',
      icon: 'pi pi-home'
    },
    {
      id: '3',
      name: 'Eventos Encerrados',
      width: '20%',
      icon: 'pi pi-home'
    },
    {
      id: '4',
      name: 'Eventos de seu interesse com prazo próximo ao fim',
      width: '40%',
      icon: 'pi pi-home'
    },
  ]
}
